import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkServer extends apiCommonCategory{
  static module = "bk_server";

  // static async getInfo(){
  //   return post('/home/bk_server/getInfo')
  // }

  static async save(data){
    return post('/home/bk_server/save', data)
  }

  static async listDel(ids) {
    return post('/home/bk_server/listDel', { ids })
  }

  static async getZ39Fields(){
    return post('/home/bk_server/getZ39Fields')
  }
}
